module.exports = __webpack_public_path__ + "img/b1.6eb6e9e3.png";